import { AppConfig } from '@pulpo/app-config';

export const environment: AppConfig = {
  production: true,
  name: 'prod',
  apiUrl: 'https://kube.pulpo.tech/',
  itemsPerPage: 10,
  loginRoute: '/login',
  backgroundImage:
    'https://photos.les-voyagistes.com/_data/i/upload/2023/12/14/20231214111123-cbf903a7-la.jpg',
  insuranceList: 'PRESENCE',
  orchestraList:
    'Lastminute;Veepee;PORCHESTRA;Carrefour;ShowRoomPrive;Speedmedia;VeryChic;Glady;Traveltribe;MyPCS;HewagoB2B;Voyamar',
  travelexchangeList: 'TE1;TE2',
  hewagoUrl: 'https://hewago.ffh.ovh',
  newBackOfficeUrl: 'https://next.pulpo.tech',
  ribbonLabel: '',
};
